import { z } from 'zod';

const regionalVideoCountryEnumValues = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas (the)',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia (Plurinational State of)',
  'Bonaire, Sint Eustatius and Saba',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory (the)',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cabo Verde',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cayman Islands (the)',
  'Central African Republic (the)',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands (the)',
  'Colombia',
  'Comoros (the)',
  'Congo (the Democratic Republic of the)',
  'Congo (the)',
  'Cook Islands (the)',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Curaçao',
  'Cyprus',
  'Czechia',
  "Côte d'Ivoire",
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic (the)',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Eswatini',
  'Ethiopia',
  'Falkland Islands (the) [Malvinas]',
  'Faroe Islands (the)',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories (the)',
  'Gabon',
  'Gambia (the)',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See (the)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran (Islamic Republic of)',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  "Korea (the Democratic People's Republic of)",
  'Korea (the Republic of)',
  'Kuwait',
  'Kyrgyzstan',
  "Lao People's Democratic Republic (the)",
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands (the)',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia (Federated States of)',
  'Moldova (the Republic of)',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands (the)',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger (the)',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands (the)',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestine, State of',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines (the)',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Republic of North Macedonia',
  'Romania',
  'Russian Federation (the)',
  'Rwanda',
  'Réunion',
  'Saint Barthélemy',
  'Saint Helena, Ascension and Tristan da Cunha',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin (French part)',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Sint Maarten (Dutch part)',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan (the)',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands (the)',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates (the)',
  'United Kingdom of Great Britain and Northern Ireland (the)',
  'United States Minor Outlying Islands (the)',
  'United States of America (the)',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela (Bolivarian Republic of)',
  'Viet Nam',
  'Virgin Islands (British)',
  'Virgin Islands (U.S.)',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe',
  'Åland Islands',
] as const;

export const regionalVideoCountrySchema = z.enum(
  regionalVideoCountryEnumValues
);

export type RegionalVideoCountry = z.infer<typeof regionalVideoCountrySchema>;

export const regionalVideoLocationPointSchema = z.object({
  lat: z.number(),
  lng: z.number(),
});

export type RegionalVideoLocationPoint = z.infer<
  typeof regionalVideoLocationPointSchema
>;

export const regionalVideoItemSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  uploadthingKey: z.string(),
  country: regionalVideoCountrySchema,
  regions: z.array(z.string()).nullable(),
  labels: z.array(z.string()).nullable(),
  cities: z.array(z.string()).nullable(),
  locationPoints: z.array(regionalVideoLocationPointSchema).nullable(),
  createdOn: z.string(),
  modifiedOn: z.string().nullable(),
});

export type RegionalVideoItem = z.infer<typeof regionalVideoItemSchema>;

// Find rows for a country (with optional overlap filters on
// regions/labels/cities). Mirrors the projected shape the legacy GET
// returns: a subset of columns.
export const findRegionalVideosInput = z.object({
  country: regionalVideoCountrySchema,
  regions: z.array(z.string()).optional(),
  labels: z.array(z.string()).optional(),
  cities: z.array(z.string()).optional(),
});

export type FindRegionalVideosInput = z.infer<typeof findRegionalVideosInput>;

export const findRegionalVideosResultItemSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  country: regionalVideoCountrySchema,
  regions: z.array(z.string()).nullable(),
  labels: z.array(z.string()).nullable(),
  cities: z.array(z.string()).nullable(),
  uploadthingKey: z.string(),
});

export type FindRegionalVideosResultItem = z.infer<
  typeof findRegionalVideosResultItemSchema
>;

export const findRegionalVideosResultSchema = z.array(
  findRegionalVideosResultItemSchema
);

export type FindRegionalVideosResult = z.infer<
  typeof findRegionalVideosResultSchema
>;

// Aggregation queries — countries listing returns {country, count}
// grouped+sorted; regions/labels/cities return a flat distinct list.
export const findRegionalVideoCountriesResultSchema = z.array(
  z.object({
    country: regionalVideoCountrySchema,
    count: z.number().int().nonnegative(),
  })
);

export type FindRegionalVideoCountriesResult = z.infer<
  typeof findRegionalVideoCountriesResultSchema
>;

export const findRegionalVideoRegionsInput = z.object({
  country: regionalVideoCountrySchema,
});

export type FindRegionalVideoRegionsInput = z.infer<
  typeof findRegionalVideoRegionsInput
>;

export const findRegionalVideoLabelsInput = z.object({
  country: regionalVideoCountrySchema,
  regions: z.array(z.string()).optional(),
});

export type FindRegionalVideoLabelsInput = z.infer<
  typeof findRegionalVideoLabelsInput
>;

export const findRegionalVideoCitiesInput = z.object({
  country: regionalVideoCountrySchema,
  regions: z.array(z.string()).optional(),
});

export type FindRegionalVideoCitiesInput = z.infer<
  typeof findRegionalVideoCitiesInput
>;

export const distinctStringListResultSchema = z.array(z.string());

export type DistinctStringListResult = z.infer<
  typeof distinctStringListResultSchema
>;

export const createRegionalVideoInput = z.object({
  name: z.string().min(1),
  uploadthingKey: z.string().min(1),
  country: regionalVideoCountrySchema,
  regions: z.array(z.string()).optional(),
  labels: z.array(z.string()).optional(),
  cities: z.array(z.string()).optional(),
  locationPoints: z.array(regionalVideoLocationPointSchema).optional(),
});

export type CreateRegionalVideoInput = z.infer<typeof createRegionalVideoInput>;

export const updateRegionalVideoInput = z.object({
  id: z.uuid(),
  name: z.string().min(1).optional(),
  uploadthingKey: z.string().min(1).optional(),
  country: regionalVideoCountrySchema.optional(),
  regions: z.array(z.string()).nullable().optional(),
  labels: z.array(z.string()).nullable().optional(),
  cities: z.array(z.string()).nullable().optional(),
  locationPoints: z
    .array(regionalVideoLocationPointSchema)
    .nullable()
    .optional(),
});

export type UpdateRegionalVideoInput = z.infer<typeof updateRegionalVideoInput>;

export const deleteRegionalVideoInput = z.object({ id: z.uuid() });

export type DeleteRegionalVideoInput = z.infer<typeof deleteRegionalVideoInput>;

export const deleteRegionalVideoResultSchema = z.object({
  success: z.literal(true),
});

export type DeleteRegionalVideoResult = z.infer<
  typeof deleteRegionalVideoResultSchema
>;
